import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const Baseurl = process.env.REACT_APP_BASE_URL;

const initialState = {
  allCategorys: [],
  categoryLoading: false,
  checkSlugurl: true,
  deleteCatLoading: true,
  error: null,
};

// ✅ Async Thunk to Add Category with JWT Token
export const categoryPost = createAsyncThunk(
  "category/categorypost",
  async (formData, { rejectWithValue, getState }) => {
    try {
      const token = getState().admin.token || sessionStorage.getItem("token");

      if (!token) {
        return rejectWithValue("No token found. Please login.");
      }

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      
        const url = `${Baseurl}/api/v1/category/new`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
      
   
      
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Category creation failed"
      );
    }
  }
);

export const getCategory = createAsyncThunk(
  "category/getAllCategory",
  async (thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/category/all`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "404 Not Found"
      );
    }
  }
);

export const categoryStatusChange = createAsyncThunk(
  "category/categoryUpdate",
  async (formData, thunkAPI) => {
    try {
      const token =
        thunkAPI.getState().admin.token || sessionStorage.getItem("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const url = `${Baseurl}/api/v1/category/setStatus/${formData.slug}`;
      const resp = await axios.put(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("status in Not set");
    }
  }
);

export const categoryUpdate = createAsyncThunk(
  "category/categoryUpdate",
  async ({formData, catUrl}, thunkAPI) => {
    try {
      const token =
        thunkAPI.getState().admin.token || sessionStorage.getItem("token");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const url = `${Baseurl}/api/v1/category/catupdate/${catUrl}`;
      const resp = await axios.put(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("category Not create");
    }
  }
);

export const categoryDelete = createAsyncThunk(
  "category/categoryDelete",
  async (slug, thunkAPI) => {
    try {
      const token =
        thunkAPI.getState().admin.token || sessionStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const url = `${Baseurl}/api/v1/category/catdelete/${slug}`;
      const resp = await axios.delete(url, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("category Not create");
    }
  }
);

const CategorySlice = createSlice({
  name: "category",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(categoryPost.pending, (state) => {
        state.categoryLoading = true;
        state.error = null;
      })
      .addCase(categoryPost.fulfilled, (state, action) => {

        if (action.payload.success) {
          state.allCategorys.push(action.payload.category);
        }
        state.categoryLoading = false;
        state.checkSlugurl = false;
      })
      .addCase(categoryPost.rejected, (state, action) => {
        state.categoryLoading = false;
        state.error = action.payload;
      })

      .addCase(getCategory.fulfilled, (state, action) => {
        state.allCategorys = action.payload.categories;
        state.categoryLoading = false;
      })
      .addCase(getCategory.rejected, (state, action) => {
        state.categoryLoading = false;
        state.error = action.payload;
      });

    builder
      .addCase(categoryStatusChange.pending, (state) => {
        state.categoryLoading = true;
      })
      .addCase(categoryStatusChange.fulfilled, (state, action) => {
        if (action.payload.success) {
          state.allCategorys = state.allCategorys.filter(
            (category) => category._id !== action.payload.category._id
          );
          state.allCategorys = [
            ...state.allCategorys,
            action.payload.category,
          ].sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1));
          localStorage.setItem(
            "allCategorys",
            JSON.stringify(state.allCategorys)
          );
        }

        state.categoryLoading = false;
      })
      .addCase(categoryStatusChange.rejected, (state) => {
        state.categoryLoading = true;
      });

      builder
      .addCase(categoryDelete.pending, (state) => {
        state.deleteCatLoading = true;
      })
      .addCase(categoryDelete.fulfilled, (state, action) => {
        if (action.payload.success) {          
          state.allCategorys = state.allCategorys.filter(
            (category) => category._id !== action.payload.id
          );
        }
        state.deleteCatLoading = false;
      })
      .addCase(categoryDelete.rejected, (state) => {
        state.deleteCatLoading = true;
      });
  },
});

export default CategorySlice.reducer;
